<template>
  <div id="app">
    <router-view/>
    <div class="footer">
      华能安阳热电有限责任公司
      <p>
        <a href="tel:0372-6317166">Tel：<span class="text_blue">0372-6317166</span></a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #F7F6F7;
  width: 100%;;
  height: 100%;
}
.footer{
  text-align: center;
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  margin-bottom: 5px;
  color: #333333;
}
.text_blue{
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue